import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { IDGDataService } from "../../../providers/idg-data-service/idg-data-service";
import { CreateCommentModalPage } from "./create-comment-modal";

@NgModule({
  declarations: [CreateCommentModalPage],
  imports: [
    IonicPageModule.forChild(CreateCommentModalPage),
    TranslateModule.forChild(),
    CommonComponentsModule,
  ],
  providers: [IDGDataService],
})
export class CreateCommentModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/inter-disciplinary-group/create-comment-modal/create-comment-modal.module.ts